import { fetchGetPublishTermsInfo } from '../../../repositories/billing-tariffs/v1/get-publish-terms-info';
import { DEFAULT_RESPONSE } from './constants';
import { IParams, IPublishTermsInfo } from './types';
import { mappers } from './utils';

export const getPublishTermsInfo = async (params: IParams): Promise<IPublishTermsInfo> => {
  const { httpApi, locationPath } = params;

  const parameters = { locationPath };

  try {
    const result = await fetchGetPublishTermsInfo({
      httpApi,
      parameters,
      mappers,
    });

    return result as IPublishTermsInfo;
  } catch (error) {
    return DEFAULT_RESPONSE;
  }
};
